import PropTypes from "prop-types";
import "./Label.css";

interface PropData {
  title?: string;
  showStar?: boolean;
  modeError?: boolean;
  type?: string;
  classNames?: string;
}

export const Label = ({
  title = "",
  showStar = false,
  modeError = false,
  type = "NORMAL",
  classNames = ""
}: PropData) => {
  return (
    <>
      {modeError === true ? (
        <p className="error">{title}</p>
      ) : (
        <label
          className={
            (type === "BOLD" ? "bold-text " : "title ") +
            (classNames ? classNames : "")
          }
        >
          {title} {showStar && <span className="req1">*</span>}
          <br></br>
        </label>
      )}
    </>
  );
};

Label.propTypes = {
  title: PropTypes.string,
  showStar: PropTypes.bool,
  modeError: PropTypes.bool,
  type: PropTypes.string,
};

// Label.defaultProps = {
//   title: "",
//   showStar: false,
//   modeError: false,
//   type: "NORMAL",
// };
